export default __webpack_public_path__ + "static/media/of_5.05a2524e.mp3";